import { useQuery } from 'react-query'

import { getTickets } from '../../endpoints/tickets'

export const useGetTickets = (p0: { enabled: boolean }) => {
    return useQuery(['tickets'], async () => await getTickets())
}
